import { captureMessage } from '@sentry/browser';
import config from 'Cloud/config';
import $ from 'jquery';
import { sendXray } from 'reactApp/utils/ga';

export default function WhatsUp() {
    const BUILD_URLS = config.get('BUILD_URLS');
    const INTERVAL = 5 * 60 * 1000;

    // раз в 5 минут проверяем WhatsUp
    window.setInterval(function() {
        $.getScript(`${BUILD_URLS.staticPath}js/WhatsUp.js?${Math.random()}`, function() {
            const whatsUp = window.WhatsUp;

            if(whatsUp instanceof Function && whatsUp.doc === 'ok') {
                sendXray('whatsup_ok');

                whatsUp();
            } else {
                sendXray('whatsup_error');

                captureMessage('WhatsUp', {
                    arguments: whatsUp.toString()
                });
            }
        });

    }, INTERVAL);
}
